import requests from "./httpService";

const UserServices = {
  async getAllUsers(user_merchant_id) {
    const data = await requests.get(
      `/customers/merchant/customer/list/${user_merchant_id}`
    );
    if (Number(data?.status) === 0) return (data?.data || []).filter(Boolean);
    return [];
  },
  async getUserById(user_merchant_id, customer_id) {
    const data = await requests.get(
      `/customers/merchant/${user_merchant_id}/customer/${customer_id}`
    );

    if (Number(data?.status) === 0) return data?.data || {};
    return {};
  },

  async getOnboardingRequirements() {
    const data = await requests.get(`/merchants/onboard/requirements`);
    if (Number(data?.status) === 0) return data?.data || {};
    return {};
  },

  deleteUser(id) {
    return requests.delete(`/user/${id}`);
  },
};

export default UserServices;
